"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTracker = void 0;

var _PublicTrackingClient = _interopRequireDefault(require("./PublicTrackingClient"));

var DEFAULT_OPTS = {
  allowUnauthed: true,
  isExternalHost: true
};

var createTracker = function createTracker() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!opts || typeof opts !== 'object') {
    opts = {};
  }

  Object.keys(DEFAULT_OPTS).forEach(function (key) {
    var value = DEFAULT_OPTS[key];

    if (typeof opts[key] === 'undefined') {
      opts[key] = value;
    }
  });
  return _PublicTrackingClient.default.createTracker(opts);
};

exports.createTracker = createTracker;